import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { CreateDealPage } from '@/features/deals';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/deals/new')({
  validateSearch: z.object({ customerId: zSearchText() }),
  staticData: { crumb: 'header.newDeal' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'deal.create', 'Deals'),
  component: function NewDeal() {
    const { customerId } = Route.useSearch();
    return <CreateDealPage customerId={customerId} />;
  },
});
